// extracted by mini-css-extract-plugin
export default {"title":"Banner_title__LO+Vd","subTitle":"Banner_subTitle__-R5xk","bannerBtn":"Banner_bannerBtn__uNSdd"};